import Api, {validToken} from 'services';

// ACTION TYPES
export const panelHasErrored = () => ({ type: '[PANEL] HAS_ERRORED' });
export const panelIsLoading = () => ({ type: '[PANEL] IS_LOADING' });
export const panelFetchSuccess = data => ({ type: '[PANEL] FETCH_SUCCESS', data });

// ACTION CREATORS
export const panel_action_get_panel = report_id => async dispatch => {
   // validToken();
  dispatch(panelIsLoading());
  await Api.Panel.getPanel(report_id)
    .then(data => {
        //console.log(data);
     return  dispatch(panelFetchSuccess(data))
    })
    .catch(() => dispatch(panelHasErrored()));
};
